import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../../api/api';
import { DISPLAY, MONO, Container, SecHead, Eyebrow, ArrowRight, Check } from './ui';

/*
 * Secciones de contenido del Home (diseño v1-marketplace). Son de
 * contenido: ninguna llama a la API salvo Marcas, que sale del catálogo.
 */

const btn = 'inline-flex items-center gap-[10px] px-[22px] py-[14px] rounded-[14px] font-bold text-[15px] transition-all hover:-translate-y-[2px]';

/* ---------- Banner de cupón ---------- */
export const PromoBanner = () => (
    <section className='py-12'>
        <Container>
            <div className='relative overflow-hidden rounded-[24px] p-12 md-lg:p-9 grid grid-cols-[1fr_auto] md-lg:grid-cols-1 gap-8 items-center text-white'
                style={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 60%, #0891b2 100%)' }}>
                <div className='absolute -top-20 -right-[60px] w-[340px] h-[340px] rounded-full pointer-events-none' style={{ background: 'radial-gradient(closest-side, rgba(251,191,36,.4), transparent)' }} />
                <div className='absolute -bottom-[100px] -left-[50px] w-[280px] h-[280px] rounded-full pointer-events-none' style={{ background: 'radial-gradient(closest-side, rgba(248,113,113,.3), transparent)' }} />
                <div className='relative z-[2]'>
                    <span className='inline-flex items-center gap-2 bg-white/[.18] border border-white/30 px-[14px] py-[6px] rounded-full text-[12px] font-extrabold tracking-[.06em] uppercase' style={{ backdropFilter: 'blur(8px)' }}>
                        <span className='w-[7px] h-[7px] rounded-full bg-[#fbbf24]' />Tiempo limitado
                    </span>
                    <h3 className='font-bold tracking-[-.02em] leading-[1.05] mt-[14px] mb-[10px]' style={{ ...DISPLAY, fontSize: 'clamp(28px, 3.6vw, 44px)', textWrap: 'balance' }}>
                        Q200 de descuento en tu primer pedido con{' '}
                        <em className='not-italic inline-block bg-[#fbbf24] text-[#1e3a8a] px-[14px] py-[2px] rounded-[10px] -rotate-2'>BIGOTES200</em>
                    </h3>
                    <p className='text-[15.5px] opacity-90 max-w-[540px] mb-[22px]'>Aplica en compras desde Q999. Solo clientes nuevos.</p>
                    <Link to='/shops' className={`${btn} bg-white text-[#1e3a8a]`}>
                        Empezar a comprar <ArrowRight />
                    </Link>
                </div>
                <div className='relative z-[2] flex flex-col items-end md-lg:items-start gap-[14px]'>
                    <span className='text-[11.5px] text-white/70 font-bold tracking-[.08em] uppercase'>Tu cupón</span>
                    <div className='bg-white text-[#1e3a8a] font-bold px-[22px] py-[14px] rounded-[14px] text-[18px] tracking-[.06em] border-[3px] border-dashed border-[#fbbf24]' style={MONO}>
                        BIGOTES200
                    </div>
                </div>
            </div>
        </Container>
    </section>
);

/* ---------- Franja de marcas ---------- */
const FALLBACK_BRANDS = ['Royal Canin', "Hill's", 'Pro Plan', 'Eukanuba', 'Whiskas', 'Pedigree', 'Bigotes Co.'];
const BRAND_STYLES = ['', 'italic', 'round'];

export const Brands = ({ products = [] }) => {
    const fromCatalog = [...new Set(products.map(p => p.brand).filter(Boolean))].slice(0, 7);
    const brands = fromCatalog.length >= 3 ? fromCatalog : FALLBACK_BRANDS;
    return (
        <section className='py-9 bg-[#faf9f6] border-y border-[#f1efea]'>
            <Container>
                <div className='flex items-center justify-around gap-6 flex-wrap'>
                    {brands.map((b, i) => {
                        const kind = BRAND_STYLES[i % 3];
                        return (
                            <span key={b}
                                className={`text-[22px] tracking-[-.01em] text-[#64748b] opacity-65 transition-all duration-200 hover:opacity-100 hover:text-[#1e3a8a] hover:scale-105 ${kind === 'italic' ? 'italic font-extrabold' : kind === 'round' ? 'font-semibold' : 'font-extrabold'}`}
                                style={kind === 'round' ? undefined : DISPLAY}>
                                {b}
                            </span>
                        );
                    })}
                </div>
            </Container>
        </section>
    );
};

/* ---------- Tarjeta de regalo ---------- */
export const GiftCard = () => (
    <section className='py-12'>
        <Container>
            <div className='relative overflow-hidden rounded-[32px] p-12 md-lg:p-9 grid grid-cols-[1.2fr_1fr] md-lg:grid-cols-1 gap-9 items-center'
                style={{ background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 60%, #fbbf24 100%)' }}>
                <span className='absolute -right-[30px] -bottom-[50px] text-[280px] leading-none opacity-10 pointer-events-none select-none' aria-hidden='true'>🎁</span>
                <div className='relative z-[2]'>
                    <span className='inline-flex items-center gap-2 bg-[#1e3a8a] text-white px-[14px] py-[6px] rounded-full text-[12px] font-extrabold tracking-[.06em] uppercase'>🎁 Regala Señor Bigotes</span>
                    <h3 className='font-bold text-[#1e3a8a] tracking-[-.02em] leading-[1.05] mt-[14px] mb-[10px]' style={{ ...DISPLAY, fontSize: 'clamp(30px, 3.8vw, 44px)', textWrap: 'balance' }}>
                        El regalo perfecto para los amantes de los peludos.
                    </h3>
                    <p className='text-[15.5px] text-[#451a03] mb-[22px] max-w-[480px]'>
                        Las tarjetas de regalo Bigotes nunca expiran y se pueden usar en toda la tienda.
                    </p>
                    <Link to='/shops' className={`${btn} bg-[#1e3a8a] text-white`}>
                        Comprar tarjeta de regalo <ArrowRight />
                    </Link>
                </div>
                <div className='relative z-[2]'>
                    <div className='relative bg-white rounded-[20px] p-6 border-2 border-white rotate-2 shadow-[0_24px_50px_-20px_rgba(146,64,14,.4)]'>
                        <div className='absolute inset-2 border-[1.5px] border-dashed border-[rgba(146,64,14,.3)] rounded-[14px] pointer-events-none' />
                        <div className='flex items-center gap-[10px] font-bold text-[#1e3a8a] text-[14px]' style={DISPLAY}>
                            <div className='w-7 h-7 rounded-full bg-[#f87171] grid place-items-center text-white text-[16px]'>🐾</div>
                            Señor Bigotes
                        </div>
                        <div className='font-extrabold text-[#1e3a8a] text-[48px] tracking-[-.02em] leading-none mt-[10px]' style={DISPLAY}>
                            Q500<small className='text-[18px] font-semibold text-[#64748b]'>.00 GTQ</small>
                        </div>
                        <div className='text-[12px] text-[#64748b] mt-[18px] tracking-[.04em]' style={MONO}>_ _ _ _ - _ _ _ _ - _ _ _ _ - 4732</div>
                    </div>
                </div>
            </div>
        </Container>
    </section>
);

/* ---------- Blog ---------- */
const POSTS = [
    { tag: 'Nutrición', meta: '10 May · Dra. Renata', title: '¿Croqueta seca o húmeda? La guía definitiva', body: 'Cuándo conviene cada una según edad y estado de salud — sin marketing, solo evidencia.', bg: 'linear-gradient(135deg, #cffafe, #e0e7ff)', emoji: '🥣' },
    { tag: 'Comportamiento', meta: '3 May · MV. Mateo V.', title: '5 señales de que tu gato te está pidiendo atención', body: 'Aprende a leer el lenguaje corporal de tu gato — y a responderle correctamente.', bg: 'linear-gradient(135deg, #e0e7ff, #fce7f3)', emoji: '🐱' },
    { tag: 'Cuidados', meta: '26 Abr · Dra. Sofía P.', title: 'Cómo preparar a tu peludo para una mudanza', body: 'Reducir el estrés del cambio con técnicas simples y comprobadas en clínica.', bg: 'linear-gradient(135deg, #fef3c7, #dcfce7)', emoji: '📦' },
];

export const Editorial = () => (
    <section className='py-12'>
        <Container>
            <SecHead title={<>Del <em>Blog Bigotes</em></>} sub='Consejos de nuestros veterinarios para que tu compañero viva mejor.' />
            <div className='grid grid-cols-3 md-lg:grid-cols-1 gap-[18px]'>
                {POSTS.map(p => (
                    <article key={p.title} className='bg-white rounded-[20px] border-[1.5px] border-[#f1efea] overflow-hidden flex flex-col transition-all duration-200 hover:-translate-y-1 hover:border-transparent hover:shadow-[0_6px_18px_-6px_rgba(15,23,42,.08)]'>
                        <div className='relative grid place-items-center text-[64px]' style={{ aspectRatio: '16 / 10', background: p.bg }}>
                            <span className='opacity-60' aria-hidden='true'>{p.emoji}</span>
                            <span className='absolute top-[14px] left-[14px] bg-white text-[#1e3a8a] text-[11px] font-extrabold px-[11px] py-[5px] rounded-full tracking-[.04em] uppercase'>{p.tag}</span>
                        </div>
                        <div className='px-[22px] pt-5 pb-6 flex flex-col gap-2 flex-1'>
                            <span className='text-[11px] text-[#64748b] font-medium tracking-[.04em] uppercase' style={MONO}>{p.meta}</span>
                            <h4 className='font-bold text-[#1e3a8a] text-[20px] m-0 tracking-[-.01em] leading-[1.2]' style={{ ...DISPLAY, textWrap: 'balance' }}>{p.title}</h4>
                            <p className='text-[14px] text-[#334155] m-0 leading-[1.55]' style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{p.body}</p>
                        </div>
                    </article>
                ))}
            </div>
        </Container>
    </section>
);

/* ---------- Newsletter ---------- */
export const Newsletter = () => {
    const [email, setEmail] = useState('');
    const [enviando, setEnviando] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!/^\S+@\S+\.\S+$/.test(email)) { toast.error('Escribe un correo válido'); return; }
        if (enviando) return;
        setEnviando(true);
        try {
            // El correo se guarda de verdad (`POST /store/newsletter`): antes se
            // agradecía y se perdía al recargar, así que el 10 % prometido no se
            // podía cumplir. Suscribirse dos veces no crea dos suscriptores.
            const { data } = await api.post('/newsletter', { email, origen: 'club' });
            toast(data.message, { icon: '🐾' });
            setEmail('');
        } catch {
            toast.error('No pudimos guardar tu correo. Intenta de nuevo.');
        } finally {
            setEnviando(false);
        }
    };
    return (
        <section className='py-14'>
            <Container>
                <div className='relative overflow-hidden rounded-[32px] p-14 md-lg:p-9 grid grid-cols-2 md-lg:grid-cols-1 gap-9 items-center text-white'
                    style={{ background: 'linear-gradient(135deg, #0b1530 0%, #1e3a8a 100%)' }}>
                    <div className='absolute -top-[100px] -left-[50px] w-[340px] h-[340px] rounded-full pointer-events-none' style={{ background: 'radial-gradient(closest-side, rgba(8,145,178,.4), transparent)' }} />
                    <div className='relative z-[2]'>
                        <Eyebrow dark>Club Bigotes</Eyebrow>
                        <h3 className='font-bold tracking-[-.02em] leading-[1.05] mt-[14px] mb-[10px]' style={{ ...DISPLAY, fontSize: 'clamp(28px, 3.4vw, 38px)', textWrap: 'balance' }}>
                            10% off en tu primera compra al unirte al Club.
                        </h3>
                        <p className='text-[15.5px] opacity-85 m-0 max-w-[440px]'>Recibe ofertas exclusivas, contenido veterinario y avisos antes que nadie. Sin spam — promesa de gato.</p>
                    </div>
                    <div className='relative z-[2] flex flex-col gap-[14px]'>
                        <form onSubmit={submit} className='flex items-center bg-white/10 border-[1.5px] border-white/20 rounded-[14px] p-[5px]' style={{ backdropFilter: 'blur(8px)' }}>
                            <input type='email' value={email} onChange={e => setEmail(e.target.value)} placeholder='tu@email.com' aria-label='Correo electrónico'
                                className='flex-1 min-w-0 bg-transparent border-none outline-none text-white text-[15px] px-[18px] h-12 placeholder:text-white/55' />
                            <button type='submit' disabled={enviando}
                                className='bg-[#f87171] hover:bg-[#ef4444] disabled:opacity-60 text-white px-[22px] h-[46px] rounded-[11px] font-bold text-[14px] transition-colors flex-shrink-0'>
                                {enviando ? 'Un momento…' : 'Suscribirme'}
                            </button>
                        </form>
                        <div className='flex gap-[18px] flex-wrap text-[13px]'>
                            {['10% en primera compra', 'Ofertas exclusivas', 'Consejos veterinarios'].map(t => (
                                <span key={t} className='inline-flex items-center gap-[7px] opacity-85'>
                                    <Check className='w-[13px] h-[13px] text-[#22d3ee]' />{t}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
};
